import { all, takeEvery, put, fork } from 'redux-saga/effects';
import { getToken, clearToken } from '../../library/helpers/utility';
import actions from './actions';
import themeSwitcherActions from '../themeSwitcher/actions';
import playerActions from '../player/actions';

const fakeApiCall = true; // auth0 or express JWT

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function*({ payload }) {
    const { token , email, userid } = payload;
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
        profile: 'Profile',
        email:email,
        userid: userid
      });
    } else {
      if (fakeApiCall) {
        yield put({
          type: actions.LOGIN_SUCCESS,
          token: 'secret token',
          profile: 'Profile',
        });
      } else {
        yield put({ type: actions.LOGIN_ERROR });
      }
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function*(payload) {
    yield localStorage.setItem('id_token', payload.token);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function*() {});
}

export function* logout(dispatch) {
  yield takeEvery(actions.LOGOUT, function*() {
    clearToken();
    yield put(playerActions.resetAudioPlayer())
    yield put(themeSwitcherActions.resetSubscription())
    yield put(themeSwitcherActions.resetCreditBalance())
    
    /*
    if(window.location.pathname !== '/signin') {
      const location = {
        pathname: '/signin',
        state: { from: {pathname: window.location.pathname} }
      }
      history.push(location);
    }*/
  });
}
export function* checkAuthorization() {
  yield takeEvery(actions.CHECK_AUTHORIZATION, function*() {
    const token = getToken().get('idToken');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        profile: 'Profile',
      });
    }
  });
}
export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
